module.exports = __webpack_public_path__ + "img/executive_session.0f9d4257.svg";